import { useSystemSetting } from "@/api/services/admin/system-setting";
import { LoadingArea } from "@/components/elements/Loading/Loading";
import { Tab } from "@/components/elements/Tab";
import { TopPage } from "@/components/elements/TopPage";
import { MaintenanceForm } from "@/features/system-setting/components/MaintenanceForm";
import { SettingForm } from "@/features/system-setting/components/SettingForm";
import { SETTING_TAB, SETTING_TAB_LABEL } from "@/features/system-setting/constants/settingTab";
import { useSettingFilterCache } from "@/features/system-setting/provider/SettingFilterCacheProvider";
import { convertEmailSettingResToForm, convertMaintenanceSettingResToForm } from "@/features/system-setting/utils/converts";
import { Box, Stack } from "@mui/material";
import { FC } from "react";

type SettingPageProps = {};

export const SettingPage: FC<SettingPageProps> = () => {
  const { settingFilterCache, setSettingFilterCache } = useSettingFilterCache();
  const searchTab = settingFilterCache?.tab || SETTING_TAB.EMAIL_SETTING;

  const { data: systemSettingResult, isLoading } = useSystemSetting();

  return (
    <Stack gap={2.5}>
      <TopPage title="システム設定" enablePageBack={false} />
      <Stack>
        <Tab
          value={searchTab}
          onChange={(_, tab) => {
            setSettingFilterCache({ tab: tab.toString() });
          }}
          options={[
            {
              label: `${SETTING_TAB_LABEL[SETTING_TAB.EMAIL_SETTING]}`,
              value: SETTING_TAB.EMAIL_SETTING,
            },
            {
              label: `${SETTING_TAB_LABEL[SETTING_TAB.MAINTENANCE_SETTING]}`,
              value: SETTING_TAB.MAINTENANCE_SETTING,
            },
          ]}
        />
        {isLoading ? (
          <Box p={3}>
            <LoadingArea />
          </Box>
        ) : (
          <>
            {searchTab === SETTING_TAB.EMAIL_SETTING && (
              <SettingForm previousData={systemSettingResult ? convertEmailSettingResToForm(systemSettingResult.data) : undefined} />
            )}
            {searchTab === SETTING_TAB.MAINTENANCE_SETTING && (
              <MaintenanceForm previousData={systemSettingResult ? convertMaintenanceSettingResToForm(systemSettingResult.data) : undefined} />
            )}
          </>
        )}
      </Stack>
    </Stack>
  );
};
